module.exports = __webpack_public_path__ + "img/process5.1f1343e4.png";